import React from "react";
import NewTagModal from "src/components/modals/NewTagModal";
import { deleteTag, getTags } from "src/api/settings";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import CustomModal from "src/components/CustomModal";
import CustomConfirmDialog from "src/components/CustomConfirmDialog";
import { buttonVariants } from "src/components/ui/button";
import { showSuccessToast } from "src/lib/utils";
import PermissionWrapper from "src/components/PermissionWrapper";

const TagSettings = () => {
	const { data } = useQuery({
		queryKey: ["tags"],
		queryFn: getTags,
		suspense: true,
	});

	const queryClient = useQueryClient();

	const { mutate: deleteMutate } = useMutation(deleteTag, {
		onSuccess: () => {
			queryClient.invalidateQueries(["tags"]);
			showSuccessToast("Tag deleted successfully");
		},
	});

	const tags = data?.data ?? [];

	return (
		<div className="settings_cont_ins tw-grid">
			<PermissionWrapper permission="add_tag">
				<CustomModal title="Add New Tag" trigger={<button className="tw-ml-auto green-btn">Add new Tag</button>}>
					<NewTagModal />
				</CustomModal>
			</PermissionWrapper>

			{tags.length > 0 ? (
				<div className="mt-3 tw-grid tw-grid-cols-[repeat(auto-fill,minmax(220px,1fr))] tw-gap-4">
					{tags.map(({ uuid, name }) => (
						<div className="tag_itm" key={uuid}>
							<span>{name}</span>
							<PermissionWrapper permission="delete_tag">
								<CustomConfirmDialog
									trigger={
										<button
											className={buttonVariants({
												variant: "hover",
												className:
													"!tw-text-red-500 tw-text-[1.5rem] hover:tw-bg-slate-200 tw-aspect-square !tw-px-2 !tw-py-1 tw-leading-none",
											})}
										>
											&times;
										</button>
									}
									mutateFn={() => deleteMutate({ uuid })}
								/>
							</PermissionWrapper>
						</div>
					))}
				</div>
			) : (
				<div className="tag_settings_cont tw-grid tw-justify-center tw-mt-10">
					<p className="mb-3 tw-text-lg">There are no tags available</p>
					<PermissionWrapper permission="add_tag">
						<CustomModal title="Add New Tag" trigger={<button className="ml-auto green-btn">Add new Tag</button>}>
							<NewTagModal />
						</CustomModal>
					</PermissionWrapper>
				</div>
			)}
		</div>
	);
};

export default TagSettings;
